<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import DumbSummaryRow from '@/components/dumb/DumbSummaryRow.vue'
import { cn } from '@/lib/utils'
import type { CriterionSummaryItem } from '@/types/CriteriaTypes'

interface CriteriaSummaryProps {
  items: CriterionSummaryItem[]
  class?: HTMLAttributes['class']
}
const props = defineProps<CriteriaSummaryProps>()

const slots = defineSlots<{
  value?: (props: { item: CriterionSummaryItem }) => unknown
}>()
</script>

<template>
  <dl
    v-if="items.length"
    :class="cn('divide-y rounded-lg border', props.class)"
  >
    <DumbSummaryRow
      v-for="item in items"
      :key="item.criterionUuid"
      :label="item.criterionName"
      :value="item.valueName"
    >
      <template v-if="slots.value" #default>
        <slot name="value" :item="item" />
      </template>
    </DumbSummaryRow>
  </dl>

  <p
    v-else
    :class="
      cn(
        'text-muted-foreground rounded-lg border px-4 py-3 text-sm',
        props.class
      )
    "
  >
    {{ $t('configuration.noCriteriaSelected') }}
  </p>
</template>
